import { State } from "~/entities/Response/FormData";

export default function (states: Array<State>) {
  try {
    const allowedStates = [];
    for (let step = 0; step < states.length; step++) {
      const country = states[step].country;
      const countryStates = allowedStates[country];
      if (
        typeof countryStates === "undefined" ||
        (countryStates && countryStates.length === 0)
      ) {
        allowedStates[country] = [];
      }
      const state = {} as State;
      Object.assign(state, states[step]);
      state.id = state.stateprovcode;
      state.label = state.stateprovcode + " - " + state.stateprov;
      allowedStates[country].push(state);
    }
    return allowedStates;
  } catch (e) {
    return false;
  }
}
